/**
 * Action registry. The world is built with a list of active actions; the
 * simulation applies each one to each entity every step. To add a future
 * action, implement the Action interface and add it here (or gate it behind a
 * feature flag when constructing the registry).
 */
import type { Action } from './action';
import { growAction } from './growAction';
import { shrinkAction } from './shrinkAction';

export { consumePulses } from './action';
export type { Action, ActionContext } from './action';

/** The default v1 action set. */
export function defaultActions(): Action[] {
  return [growAction, shrinkAction];
}
